import {healthBGC} from "../../_signals/s_char_calc";
import {Item, LLabel} from "../CharStyled";
import {s_char} from "../../_signals/s_char";
import React from "react";

export default function CharSchaden() {
    return <Item className="healthBGC"
                 style={{
                     borderColor: healthBGC(),
                     borderWidth: 8,
                     borderStyle: 'solid',
                 }}
    >
        <LLabel>Akt. Schaden</LLabel>
        <div>{s_char.value.schaden}</div>
    </Item>
}